/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable object-shorthand */
import * as moment from 'moment';
import { UserService } from '../../pages/com.usblick.common/auth/user.service';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { NavigationExtras } from '@angular/router';
import { RestService } from './../../shared/rest.service';
import { ProductFactoryService } from 'services/itinerary/products/product-factory.service';
import { IProductReservationParams } from 'model/product.interface';

export async function payload(
  items: any,
  paxes: any,
  userService: UserService,
  itineraryId: any,
  commentRentACar: any,
  groupedByBookingCode: any,
  restService: RestService,
  itineraryItems: any,
  paxesInItems: any,
  nameHotel: any,
  productFactory: ProductFactoryService
): Promise<any> {
  const products: any = {};
  products['product'] = [];

  for (const item of items) {
    const category = item.categoryName;

    switch (category) {
      case 'HOTELS':
        products.product.push(buildHotelPayload(item, paxes, userService, itineraryId));
        break;

      case 'TOURS':
        products.product.push(buildTourPayload(item, paxes, itineraryId, nameHotel, itineraryItems));
        break;

      case 'RENT-A-CAR':
        products.product.push(buildRentACarPayload(item, paxes, itineraryId, commentRentACar, paxesInItems));
        break;

      case 'TRANSPORTS':
        if (item.firstWay === 1 || item.totalWay === 1) {
          products.product.push(buildTransportPayload(item, paxes, itineraryId,  groupedByBookingCode, itineraryItems,  userService, paxesInItems));
        }
        break;
      case 'INSURANCE':
        const productService = productFactory.getProductService(10);
        const params: IProductReservationParams = {
          item,
          paxes,
          itineraryId,
          othersPerCategory: {
            paxesInItems: paxes,
            itemId: item.id,
            channelId: userService._channel_id,
            clientIdFusion: userService.clientIdFusion,
            itineraryItems
          }
        };
        const product = productService.createReserve(params);
        products.product.push(product);
        break;

      case 'FLIGHTS':
        const flightProductService = productFactory.getProductService(5);
        const flightParams: IProductReservationParams = {
          item,
          paxes,
          itineraryId,
          othersPerCategory: {
            paxesInItems: paxes,
            itemId: item.id,
            channelId: userService._channel_id,
            clientIdFusion: userService.clientIdFusion,
            itineraryItems
          }
        };
        const flightProduct = flightProductService.createReserve(flightParams);
        products.product.push(flightProduct);
        break;

      default:
        console.warn(`Unknown category: ${category}`);
        break;
    }
  }

   if (products.product && products.product.length > 0) {
      return await createReserve(products, itineraryId, restService);
    } else {
      return Promise.resolve({ message: 'No products to send' });
    }
}

function buildHotelPayload(
                            item: any,
                            paxes: any,
                            userService: any,
                            itineraryId: any,

                          ): any {
  const isDisney = item.categoryName === 'DISNEY';
  const otherItems = {};
  otherItems['userService'] = userService;

  return {
    id: item.id,
    searchId: item.searchId,
    providerId: item.providerId,
    providerName: item.providerName,
    title: item.title,
    description: '',
    categoryId: item.category_id,
    itinerary_id: itineraryId,
    productId: item.idProduct,
    channelId: userService._channel_id,
    clientId: userService.clientIdFusion,
    clientName: userService._agencyName,
    agencyName: userService._agencyName,
    agencyId: userService._agencyID.toString(),
    origin: !isDisney ? item.payloadUpdate.products[0]?.origin ?? null : null,
    destination: !isDisney
      ? item.payloadUpdate.products[0]?.destination ?? 'KOA'
      : item.destination.iata_code,
    nationality: item.payloadUpdate.products[0]?.nationality,
    dateIni: isDisney
      ? new DatePipe('en-US').transform(item.destination.destination_info.arrival, 'yyyy-MM-dd')
      : item.arrivalDate,
    dateEnd: isDisney
      ? new DatePipe('en-US').transform(item.destination.destination_info.departure, 'yyyy-MM-dd')
      : item.departureDate,
    nameAdapter: !isDisney ? item.payloadUpdate.products[0]?.nameAdapter : 'Majestic_Disney',
    additionalInfo: setAdditionalInfo(item, paxes, otherItems),
  };
}

function buildTourPayload(item: any, paxes: any, itineraryId: any, nameHotel: any, itineraryItems): any {

  let id: any;
  const otherItems = {};
  otherItems['itineraryItems'] = itineraryItems;
  if(item.subCategoryId === 6) {
    id = item.id;
  }
  if(item.subCategoryId === 9) {
    id = item.idProduct;
  }

  return {
    id: item.id,
    searchId: item.searchId,
    providerId: item.payloadUpdate.products[0].providerId,
    itinerary_id: itineraryId,
    title: item.title,
    description: item.description,
    categoryId: item.subCategoryId,
    productId: id,
    destination: item.destination.iata_code,
    dateIni: item.arrivalDate,
    dateEnd: item.departureDate,
    bookingCode: item.bookingCode,
    additionalInfo: setAdditionalInfo(item, paxes, otherItems, undefined, nameHotel),
  };
}

function buildRentACarPayload(item: any, paxes: any, itineraryId: any, commentsRentacar: any, paxesInItems: any): any {
  return {
    searchId: item.searchId,
    id: item.id,
    providerId: item.providerId,
    itinerary_id: itineraryId,
    categoryId: item.category_id,
    productId: item.rentacarId,
    pickup: item.destination.iata_code,
    dropoff: item.destination.iata_code,
    dateIni: item.arrivalDate,
    dateEnd: item.departureDate,
    // codereference: item.rentacarId,
    BookingCode: item.RatePlanCode,
    comments: commentsRentacar, //falta este
    Comments: commentsRentacar,
    additionalInfo: setAdditionalInfo(item, paxes, paxesInItems),
  };
}

 function buildTransportPayload(item: any, paxes: any, itineraryId: any, groupedByBookingCode: any, itineraryItems: any, userService: any, paxesInItems: any): any {
  const otherItems = {};
  otherItems['itineraryItems'] = itineraryItems;
  otherItems['userService'] = userService;
  otherItems['paxes'] = paxes;
  otherItems['paxesInItems'] = paxesInItems;

  // groupedByBookingCode[bookParam] es un array de pares [id1, id2] ya
  // cerrados por firstWay 1+2; se busca el par al que pertenece este item,
  // porque un mismo bookParam puede tener varios pares ida/vuelta.
  const pairsForBookingCode: any[][] = groupedByBookingCode[item.bookParam] || [];
  const matchingPair = pairsForBookingCode.find(pair => pair.includes(item.id)) || null;
  let doubleWay: any = null;

  if(matchingPair !== null && matchingPair.length === 2) {
    doubleWay = matchingPair;
  }

  return {
    id: item.id,
    providerId: item.providerId,
    itinerary_id: itineraryId,
    categoryId: item.category_id,
    agencyId: userService._agencyID,
    clientId: userService.clientIdFusion,
    agencyData:
    {
    agencyId: userService._agencyID,
    agencyEmail: userService._email,
    agencyName: userService._agencyName,
    agentName: userService._name
    },
    productId: item.productId,
    pickupDate: item.payloadSync.pickupDate,
    dropoffDate: item.payloadSync.dropoffDate,
    typeOriginPickup: item?.payload[0]?.transfers?.pickupLocation?.type === 'hotel' ? 'hotel' : item?.payload[0]?.transfers?.pickupLocation?.originDateTransfers,
    typeOriginDropoff: item?.payload[0]?.transfers?.dropoffTime ? item?.payload[0]?.transfers?.dropoffLocation?.type === 'hotel'
                                                     ? 'hotel'
                                                     : item?.payload[0]?.transfers?.dropoffLocation?.originDateTransfers
                                                     : null,
    transferId: item.productId,
    doubleWay: doubleWay,
    additionalInfo: setAdditionalInfo(item, paxes, otherItems, paxesInItems),
  };
}

function buildInsurancePayload(item: any, paxes: any, itineraryId: any): any {

  return {
            user_id: 1,
            operator_id: 1,
            channelId: 3,
            numberConfirmationClient: '465466',
            providerId: 'zoco_providers',
            providerName: 'ZOCO',
            title: 'Test Reserva de Plan',
            description: 'plan ONLY',
            clientId: 2,
            clientName: 'Test Asistencia',
            currencyId: 'USD',
            marketingId: 2,
            dateIni: '2025-07-25',
            dateEnd: '2025-07-29',
            observation: '',
            // additionalInfo: setAdditionalInfo(item, paxes, otherItems, paxesInItems),
  };
}

function setAdditionalInfo(item: any, paxes: any, otherItems?: any, paxesInItems?: any, nameHotel?: any): any {

  switch (item.categoryName) {
    case 'HOTELS':
      return buildHotelInfo(item, paxes, voucherData(item), rooms(item, paxes, otherItems['userService']['itineraryActive'][0]));

    case 'TOURS':
      return buildTourInfo(item, paxes, setPaxesFn, questionsFn, nameHotel, otherItems['itineraryItems']);

    case 'TRANSPORTS':
      return buildTransportInfo(item, otherItems['itineraryItems'], otherItems['userService']['itineraryActive'][0], setPaxesFn(otherItems['paxesInItems'], 'TRANSPORTS'));

    case 'INSURANCE':
      return buildInsuranceInfo(item, paxes, this.setPaxesReserve.bind(this));

    case 'PTHEMES':
      return buildPthemesInfo(item, paxes, this.setPaxesReserve.bind(this));

    case 'DISNEY':
      return buildDisneyInfo(item, paxes, this.setPaxesReserve.bind(this));

    case 'RENT-A-CAR':
      return buildRentacarInfo(item, setPaxesFn, paxes);

    default:
      return null;
  }
}

function voucherData(item: any): any {
   return {
      hotelAdditionalInfo: {
        timeInformation: {
          checkIn: item?.hotelAdditionalInfo?.TimeInformation?.checkIn,
          checkOut: item?.hotelAdditionalInfo?.TimeInformation?.checkOut,
        },
        coordinates: {
          latitude: item?.hotelAdditionalInfo?.coordinates?.latitude,
          longitude: item?.hotelAdditionalInfo?.coordinates?.longitude,
        },
        city: item?.hotelAdditionalInfo?.city,
        country: item?.hotelAdditionalInfo?.country,
        starRating: item?.hotelAdditionalInfo?.starRanting,
        zipCode: item?.hotelAdditionalInfo?.zipCode,
        location: item?.hotelAdditionalInfo?.location,
      },
      form: {
        qtyAdults: item?.form?.room?.qtyAdults,
        qtyChilds: item?.form?.room?.qtyChilds,
        childsAge: item?.form?.room?.childsage,
      },
      roomType: item?.roomType,
      boardname: item?.roomsData[0]?.boardName,
      cancellation_policy: item?.roomsData[0]?.cancellation_policy,
      description: item?.roomsData[0]?.description,
    };
}



function rooms(item: any, paxes: any, itineraryActive: any): any {

  const rooms: any[] = [];

  for (let i = 0; i < item.roomsData.length; i++) {
    const roomData = item.roomsData[i];

    const room = {
      id: roomData.id ? roomData.id : null,
      bookParam: roomData.bookingCode ? '\'' + roomData.bookingCode + '\'' : null,
      roomId: roomData.roomId ? roomData.roomId : null,
      optionId: roomData.optionId ? roomData.optionId : null,
      accomodationId: roomData.accomodationId ? roomData.accomodationId : null,
      maxPax: 1,
      tax: roomData.taxNightsPriceTotal ? roomData.taxNightsPriceTotal : null,
      netPrice: roomData.netPriceFreeTax,
      netTotalPrice: roomData.netPriceProf,
      totalNetPrice: roomData.optionNightsNetTotalFreeTax,
      totalPrice: roomData.room?.pricing?.priceWithTax,
      currency: roomData.room?.pricing?.currency,
      promotion: {
        promotionApplied: roomData?.room?.promotions && roomData?.room?.promotions.promotionApplied && roomData?.room?.promotions.promotionApplied.length > 0 ? true : false,
        promotionsId: roomData?.room?.promotions && roomData?.room?.promotions.promotionApplied && roomData?.room?.promotions.promotionApplied.length > 0 ? [roomData?.room?.promotions.promotionApplied[0].id] : [],
      },
      percentage: roomData.percentage ? roomData.percentage : null,
      paxList: setPaxesFn(paxes, 'HOTELS', roomData.id, roomData?.form?.nationality),
      request: roomData.remarksSelect ? roomData.remarksSelect : initializeRemarksSelect(),
      comments: roomData.comments ? roomData.comments : '',
    };

    // FlightDetails si aplica
    if (roomData.flightMandatory) {
      room['FlightDetails'] = [
        {
          IsFlightOutbound: true,
          ArriveDate: itineraryActive?.fly?.arrivalIn,
          DepartDate: '2025-07-15T00:00:00Z',
          Number: itineraryActive?.fly?.flyNumberIn,
          From: 'LESJ',
          To: itineraryActive?.fly?.airportIataCodeIn
        },
        {
          IsFlightOutbound: false,
          ArriveDate: '2025-07-18T12:00:00Z',
          DepartDate: itineraryActive?.fly?.departureOut,
          Number: itineraryActive?.fly?.flyNumberOut,
          From: itineraryActive?.fly?.airportIataCodeOut,
          To: 'LESJ'
        }
      ];
    }

    // Extras si hay addonsIncluded
    if (roomData.room?.addonsIncluded && roomData.room.addonsIncluded.length > 0) {
      const payloadExtras = roomData.payloadUpdate?.products?.[0]?.others?.hotels?.roomConfiguration?.[0]?.extras || [];
      const extraIdMap = new Map();

      payloadExtras.forEach((extra: any) => {
        if (extra.optionId && extra.extraId) {
          extraIdMap.set(extra.optionId, extra.extraId);
        }
      });

      room['Extras'] = roomData.room.addonsIncluded.map((addon: any) => {

        const extraId = extraIdMap.get(addon.optionid);
        return extraId ? {
          ExtraId: parseInt(extraId),
          OptionId: parseInt(addon.optionid),
          ExpectedNetCost: {
            Amount: addon.netcost?.amount,
            Currency: addon.netcost?.currency
          }
        } : null;
      }).filter(Boolean); // Filtrar nulls
    }

    rooms.push(room);
  }

  return rooms;
}

// Imports necesarios
// Si las funciones usan helpers, pasalos como parámetros
// Evitá acoplarlas a `this` directamente

function buildHotelInfo(item: any, paxes: any, voucherDataFn: any, roomsFn: any) {
  return {
    voucherData: voucherDataFn,
    hotelId: item.room.hotelCode,
    roomQty: 1,
    arrival: item.arrivalDate,
    departure: item.departureDate,
    rooms: roomsFn,
  };
}

 function roomsFn(item: any, paxes: any): any[] {
    const rooms: any[] = [];

    // Itera sobre todos los elementos de roomsData para unirlos en un solo array
    for (let i = 0; i < item.roomsData.length; i++) {
      rooms.push({
        id: item.roomsData[i].id ? item.roomsData[i].id : null,
        bookParam: item.roomsData[i].bookingCode ? '\'' + item.roomsData[i].bookingCode + '\'' : null,
        roomId: item.roomsData[i].roomId ? item.roomsData[i].roomId : null,
        optionId: item.roomsData[i].optionId ? item.roomsData[i].optionId : null,
        accomodationId: item.roomsData[i].accomodationId ? item.roomsData[i].accomodationId : null,
        maxPax: 1,
        tax: item.roomsData[i].tax ? item.roomsData[i].tax : null,
        netPrice: item.roomsData[i].netPriceFreeTax,
        netTotalPrice: item.roomsData[i].netPriceProf,
        totalNetPrice: item.roomsData[i].optionNightsNetTotalFreeTax,
        totalPrice: item.roomsData[i].optionNightsNetTotalProf,
        currency: item.room?.pricing?.currency,
        percentage: item.roomsData[i].percentage ? item.roomsData[i].percentage : null,
        promotion: item.roomsData[i].promotions[0] ? item.roomsData[i].promotions[0] : null,
        paxList: setPaxesFn(paxes, 'HOTELS', item.roomsData[i].id, item.roomsData[i]?.form?.nationality),
        request: item.roomsData[i].remarksSelect ? item.roomsData[i].remarksSelect :  initializeRemarksSelect(),
        comments: item.roomsData[i].comments ? item.roomsData[i].comments : '',
      });
    }

    return rooms;
  }

function buildTourInfo(item: any, paxes: any, setPaxesFn: any, questionsFn: any, nameHotel: any, itineraryItems: any) {

  let addonsIncluded: any[] = [];

  const findItem = itineraryItems.find(c => c.productKey === item.productKey);
  const comments = findItem?.comments || '';

  if(item.subCategoryId === 6) {
    addonsIncluded = item.experience.addonsIncluded;
  }
  if(item.subCategoryId === 9) {
    addonsIncluded = [];
  }

  return {
    tours: [
      {
        netPrice: item.totalPrice,
        serialized: false,
        company: item.company,
        optionId: item.optionId,
        paxAdults: item.paxAdults,
        paxChildren: item.paxChildren,
        operationDateFrom: item.selectDay,
        operationDateTo: item.selectDay,
        iataCode: item.iata_code,
        marketingId: 2,
        currency: item.currency,
        extras: getExtrasTour(addonsIncluded),
        totalNetPrice: item.netPriceUnitary,
        totalPrice: item.netPriceUnitary,
        bookingCode: item.bookingCode || null,
        rateKey: item.bookingCode || null,
        paxList: setPaxesFn(paxes, 'TOURS', item.id),
        question: questionsFn(item, paxes, nameHotel),
        session: item.selectHour,
        comments,
      },
    ],
  };
}

export function getExtrasTour(addons: any): any[] {
  // Validar que addons sea un array no vacío
  if (!Array.isArray(addons) || addons.length === 0) {
    return [];
  }

  return addons
    .filter(addon => addon && (addon.id || addon.name)) // Filtrar elementos válidos
    .map(addon => ({
      // Usar valores por defecto seguros
      id: addon.id || addon.addonId || `extra-${Date.now()}-${Math.random()}`,
      price: Number(addon.totalPrice || addon.price || addon.cost || 0),
    }));
}

function buildTransportInfo(item: any, itineraryItems: any[], itineraryActive: any, setPaxesFn: any) {

  const findItem = itineraryItems.find(c => c.productKey === item.productKey);
  const comments = findItem?.comments || '';

  const amenities: any[] = [];

  if(item.amenities && item.amenities.length > 0) {
    item.amenities.forEach((amenity: any) => {
      if(amenity.included) {
        amenities.push({price: amenity.priceProf,
                        type:amenity.type,
                        id: amenity?.id ? amenity?.id : null,
                        optionSelected: amenity?.optionSelected ? amenity.optionSelected.toString() : null
                      });
      }
    });
  };

  if(item.amenitiesIncluded && item.amenitiesIncluded.length > 0) {
    item.amenitiesIncluded.forEach((amenity: any) => {
      amenities.push({
                      price: amenity.price,
                      type: amenity?.type ? amenity.type : null,
                      id: amenity?.id ? amenity?.id : null,
                      optionSelected: amenity?.optionSelected ? amenity.optionSelected.toString() : null
                    });
    });
  };

  const originTypeAirport = item.formTransport.firstOrigin?.type === 'airport';
  const originTypeAirportNac = item?.selectedFlight?.cityArrivalOut;
  const destinationTypeAirport = item.formTransport.firstDestination?.type === 'airport';

  return {
    transfers: [
      {
        bookingCode: item.bookingCode || null,
        amenities: amenities,
        oneWay: item.payload[0].transfers.oneWay,
        comments,
        vehicleCode: item.vehicleCode,
        maxPax: item.maxPax,
        currency: item.currency,
        totalPrice: item.totalPrice,
        priceWithoutTax: item.priceWithoutTax,
        goingWay: getFlightGoingWay(item, originTypeAirport, originTypeAirportNac),
        returnWay: getFlightReturnWay(item, destinationTypeAirport, originTypeAirportNac),
        paxList: setPaxesFn
      }
    ]
  };
}

function getFlightNationalWay(flight: any): any {
  // Nacional: el dato siempre viaja en los campos "Out" (número de vuelo y
  // aerolínea no cambian). Solo la fecha invierte según flight_direction:
  // ARRIVAL usa arrivalOut, DEPARTURE (o default) usa departureOut.
  const isArrival = flight.flight_direction === 'ARRIVAL';

  return {
    travelId: flight.flyNumberOut || null,
    travelInfo: flight.airlineIataCodeOut || null,
    travelCompanyName: flight.airlineOut || null,
    travelDate: (isArrival ? flight.arrivalOut : flight.departureOut) || null
  };
}

function getFlightGoingWay(item, originTypeAirport, originTypeAirportNac): any {
  if (!item?.selectedFlight) {
return null;
}

  const flight = item.selectedFlight;

  if (originTypeAirportNac) {
    return getFlightNationalWay(flight);
  }

  const isOutbound = originTypeAirportNac;

  return {
    travelId: isOutbound
      ? (flight.flyNumberOut || flight.flyNumberIn || null)
      : (flight.flyNumberIn || flight.flyNumberOut || null),
    travelInfo: isOutbound
      ? (flight.airlineIataCodeOut || flight.airlineIataCodeIn || null)
      : (flight.airlineIataCodeIn || flight.airlineIataCodeOut || null),
    travelCompanyName: isOutbound
      ? (flight.airlineOut || flight.airlineIn || null)
      : (flight.airlineIn || flight.airlineOut || null),
    travelDate: isOutbound
      ? (flight.departureOut || flight.arrivalIn || null)
      : (flight.arrivalIn || flight.departureOut || null)
  };
}

function getFlightReturnWay(item, destinationTypeAirport, originTypeAirportNac): any {
  if (!item?.selectedFlight) {
return null;
}

  const flight = item.selectedFlight;

  if (originTypeAirportNac) {
    return getFlightNationalWay(flight);
  }

  return {
    travelId: flight.flyNumberOut || flight.flyNumberIn || null,
    travelInfo: flight.airlineIataCodeOut || flight.airlineIataCodeIn || null,
    travelCompanyName: flight.airlineOut || flight.airlineIn || null,
    travelDate: flight.departureOut || flight.arrivalIn || null
  };
}

 function buildInsuranceInfo(item: any, paxes: any, setPaxesFn: any) {

  return {
    insurancId: item.id,
    planQty: item.plans,
    plans: getInfoPlans(item.plans),
  };
}

function getInfoPlans(plans: any[]): any[] {

  if(plans && plans.length === 0) {
    return null;
  }

  const plansArr: any[] = [];

  plans.forEach((plan: any) => {
    plansArr.push({
                        bookingCode: '726316358~2~2~20250711090727',
                        planId: '2',
                        planCode: 'ZOC2-R',
                        maxPax: 1,
                        netPrice: 104,
                        totalNetPrice: 104,
                        totalPrice: 104,
                        tax: 0,
                        percentage: 10,
                        planConfiguration: {
                            qtyPax: 1,
                            paxAges: [25]
                        },
                        paxList: plan,
    });

  });

  return plansArr;
}

 function buildPthemesInfo(item: any, paxes: any, setPaxesFn: any) {
  return {
    arrival: item.arrivalDate,
    departure: item.departureDate,
    paxList: {
      pax: setPaxesFn(paxes, 'PTHEMES'),
    },
    optionId: item.optionId,
    price: item.priceAdults,
  };
}

 function buildDisneyInfo(item: any, paxes: any, setPaxesFn: any) {
  return {
    searchId: item.hotel['additionalInfo']['searchId'],
    hotelId: item.hotel.id,
    roomId: item.room.roomId,
    accId: item.room.accomodationId,
    rateId: item.plan.rateId,
    ticketTypeId: item.ticket?.id || 0,
    mealPlanId: item.mealPlan?.id || 0,
    arrivalDate: item.destination.destination_info.arrival,
    departureDate: item.destination.destination_info.departure,
    days: item.days,
    noExpiration: false,
    paxList: setPaxesFn(paxes, 'DISNEY'),
    price: item.room.netPrice,
  };
}

function buildRentacarInfo(item: any, setPaxesFn: any, paxes?: any) {
  const rental = item.payloadUpdate.products[0].others.carRental;
  return {
    carRental: [
      {
        pickupTime: rental.pickupLocation.pickupTime,
        dropoffTime: rental.dropoffLocation.dropoffTime,
        pickupLocationId: rental.pickupLocation.origin,
        dropoffLocationId: rental.dropoffLocation.destination,
        FlightTime: '0001-01-01T00:00:00',
        FlightNumber: 'XX1234',
        selectedAdditionals: buildAddonsSelectedRentacar(item),
        paxes: setPaxesFn(paxes[0], 'RENT-A-CAR'),
      }
    ]
  };
}

function setPaxesFn(pax: any, category: any, itemId?: any, nationality?: string): any {

    const paxLength: number = pax.length;
    let paxesAux = [];
    let paxes = [];
    let n = 1;

    if (pax !== undefined) {
      // Itera sobre cada array en pax
      pax.forEach((subArray) => {
        if (Array.isArray(subArray)) {
          // Filtra los elementos cuyo itemId está en la lista proporcionada
          const filteredItems = subArray.filter((item) => itemId == item.itemId);

          // Agrega los elementos filtrados a paxesAux
          paxes.push(...filteredItems);
        }
      });
    }
    if (paxes.length > 0 && itemId !== undefined) {
      for (let i = 0; i < paxes.length; i++) {
        const birth_date = moment(paxes[i].birth_date, ['DD-MM-YYYY', 'YYYY-MM-DD', 'YYYY-DD-MM', 'MM-DD-YYYY']).format('YYYY-MM-DD');

        switch (category) {
          case 'HOTELS':
            paxesAux.push({
              clientId: paxes[i].clientId,
              gender: paxes[i].gender,
              title: paxes[i].title,
              firstName: paxes[i].first_name,
              lastName: paxes[i].last_name,
              identificationType: paxes[i].identificationType,
              identification: paxes[i].document_number,
              type: paxes[i].type === 'AD' ? 'AD' : 'CH',
              birth_date: birth_date,
              age: paxes[i].age,
              email: paxes[i].email ? paxes[i].email : paxes[0].email,
              phone: paxes[i].phone ? paxes[i].phone : paxes[0].phone,
              address: paxes[i].address ? paxes[i].address : paxes[0].address,
              nationality: nationality ? nationality : 'AR',
              country: paxes[i].country_id ? paxes[i].country_id : paxes[0].country_id,
              city: paxes[i].city ? paxes[i].city : paxes[0].city,
              idUnique: paxes[i].idUnique,
              paxListIndex: paxes[i].paxListIndex,
              state: paxes[i].state_id ? paxes[i].state_id : paxes[0].state_id,
              relation_ship_catalogue_id: paxes[i].relation_ship_catalogue_id,
              holder: i == 0 ? true : false,
            });
            n = i + 1;
            break;
          case 'TOURS':

            paxesAux.push({
              clientId: paxes[i].clientId,
              gender: paxes[i].gender,
              title: paxes[i].title,
              firstName: paxes[i].first_name,
              lastName: paxes[i].last_name,
              identificationType: paxes[i].identificationType,
              identification: paxes[i].document_number,
              type: paxes[i].type === 'AD' ? 'AD' : 'CH',
              birth_date: birth_date,
              age:paxes[i].age,
              email: paxes[i].email ? paxes[i].email : paxes[0].email,
              phone: paxes[i].phone ? paxes[i].phone : paxes[0].phone,
              address: paxes[i].address ? paxes[i].address : paxes[0].address,
              nationality: nationality ? nationality : 'AR',
              country: paxes[i].country_id ? paxes[i].country_id : paxes[0].country_id,
              city: paxes[i].city ? paxes[i].city : paxes[0].city,
              idUnique: paxes[i].idUnique,
              paxListIndex: paxes[i].paxListIndex,
              state: paxes[i].state_id ? paxes[i].state_id : paxes[0].state_id,
              relation_ship_catalogue_id: paxes[i].relation_ship_catalogue_id,
              holder: i == 0 ? true : false,
            });
            n = i + 1;
            break;
          case 'RENT-A-CAR':
            paxesAux.push({
              clientId: paxes[i].clientId,
              gender: paxes[i].gender,
              title: paxes[i].title,
              firstName: paxes[i].first_name,
              lastName: paxes[i].last_name,
              identificationType: paxes[i].identificationType,
              identification: paxes[i].document_number,
              type: paxes[i].type === 'AD' ? 'AD' : 'CH',
              birth_date: birth_date,
              age: paxes[i].age,
              email: paxes[i].email ? paxes[i].email : paxes[0].email,
              phone: paxes[i].phone ? paxes[i].phone : paxes[0].phone,
              address: paxes[i].address ? paxes[i].address : paxes[0].address,
              nationality: nationality ? nationality : 'AR',
              country: paxes[i].country_id ? paxes[i].country_id : paxes[0].country_id,
              city: paxes[i].city ? paxes[i].city : paxes[0].city,
              idUnique: paxes[i].idUnique,
              paxListIndex: paxes[i].paxListIndex,
              state: paxes[i].state_id ? paxes[i].state_id : paxes[0].state_id,
              relation_ship_catalogue_id: paxes[i].relation_ship_catalogue_id,
              holder: i == 0 ? true : false,
            });
            n = i + 1;
            break;
          case 'TRANSPORTS':
            paxesAux.push({
              clientId: paxes[i].clientId,
              gender: paxes[i].gender,
              title: paxes[i].title,
              firstName: paxes[i].first_name,
              lastName: paxes[i].last_name,
              identificationType: paxes[i].identificationType,
              identification: paxes[i].document_number,
              type: paxes[i].type === 'AD' ? 'AD' : 'CH',
              birth_date: birth_date,
              age: paxes[i].age,
              email: paxes[i].email ? paxes[i].email : paxes[0].email,
              phone: paxes[i].phone ? paxes[i].phone : paxes[0].phone,
              address: paxes[i].address ? paxes[i].address : paxes[0].address,
              nationality: nationality ? nationality : 'AR',
              country: paxes[i].country_id ? paxes[i].country_id : paxes[0].country_id,
              city: paxes[i].city ? paxes[i].city : paxes[0].city,
              idUnique: paxes[i].idUnique,
              paxListIndex: paxes[i].paxListIndex,
              state: paxes[i].state_id ? paxes[i].state_id : paxes[0].state_id,
              relation_ship_catalogue_id: paxes[i].relation_ship_catalogue_id,
              holder: i == 0 ? true : false,
            });
            n = i + 1;
            break;
        }
      }
    }

    if (paxLength > 0 && itemId === undefined) {
        let paxAux: any[] = [];
        paxAux = pax || [];
        const sharedCategories = ['HOTELS', 'TOURS', 'RENT-A-CAR', 'TRANSPORTS'];

        // GUARDAR EL PRIMER PAX ORIGINAL (antes de procesarlo)
        const firstPaxOriginal = paxAux.length > 0 ? {...paxAux[0]} : {};

        for (let i = 0; i < paxAux.length; i++) {
            // Validar que exista el pasajero en el índice actual
            const currentPax = paxAux[i];
            if (!currentPax) {
                console.warn(`Pasajero no encontrado en índice ${i}`);
                continue;
            }

            // ✅ Calcular fecha de nacimiento y edad de forma segura (SOLO UNA VEZ)
            let birth_date = null;
            let Age = null;

            if (currentPax.birth_date) {
                try {
                    const momentDate = moment(currentPax.birth_date, [
                        'DD-MM-YYYY',
                        'YYYY-MM-DD',
                        'DD/MM/YYYY',
                        'YYYY/MM/DD'
                    ]);

                    if (momentDate.isValid()) {
                        birth_date = momentDate.format('YYYY-MM-DD');
                        Age = currentPax?.age;

                    } else {
                        console.warn(`⚠️ Índice ${i}: No se pudo parsear fecha: ${currentPax.birth_date}`);
                    }
                } catch (error) {
                    console.error(`❌ Error procesando fecha para índice ${i}:`, error);
                }
            }

            // Verificar si la categoría está en las compartidas
            if (sharedCategories.includes(category)) {
                // FUNCIONES DE VALIDACIÓN
                const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
                const isValidPhone = (phone: string) => /^\d{6,}$/.test(phone.replace(/\D/g, ''));
                const isValidName = (name: string) => /^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/.test(name);

                const isValidDocument = (doc: string, docType: any) => {
                    if (!doc || doc.trim() === '') {
                      return false;
                      }
                                          const docString = doc.toString().trim();
                                          const type = docType?.toString();
                                          if (type === '4') {
                      return /^[0-9]+$/.test(docString);
                      } else if (type === '5') {
                      return /^[a-zA-Z0-9]+$/.test(docString);
                      } else {
                      return docString !== '';
                      }
                };

                const getDocumentType = (current: any, first: any) => current?.identificationType ?? first?.identificationType ?? null;

                const getValidatedDocument = (currentDoc: any, currentType: any, firstDoc: any, firstType: any) => {
                    if (currentDoc && isValidDocument(currentDoc, currentType)) {
                            return currentDoc;
                            }
                    if (firstDoc && isValidDocument(firstDoc, firstType)) {
                      return firstDoc;
                      }
                    return null;
                };



                // Obtener tipos de documento
                const currentDocType = currentPax.identificationType;
                const firstPaxDocType = firstPaxOriginal.identificationType;

                // ✅ CREAR EL OBJETO DE PASAJERO (sin doble parseo de fecha)
                const paxObject = {
                    clientId: currentPax.clientId ?? null,
                    gender: (['M', 'F', 'O'].includes(currentPax.gender) ? currentPax.gender :
                            (['M', 'F', 'O'].includes(firstPaxOriginal.gender) ? firstPaxOriginal.gender : null)),
                    title: (['Mr.', 'Mrs.', 'Ms.', 'Miss', 'Dr'].includes(currentPax.title) ? currentPax.title :
                           (['Mr.', 'Mrs.', 'Ms.', 'Miss', 'Dr'].includes(firstPaxOriginal.title) ? firstPaxOriginal.title : null)),
                    firstName: (isValidName(currentPax.first_name) ? currentPax.first_name :
                               (isValidName(firstPaxOriginal.first_name) ? firstPaxOriginal.first_name : null)),
                    lastName: (isValidName(currentPax.last_name) ? currentPax.last_name :
                              (isValidName(firstPaxOriginal.last_name) ? firstPaxOriginal.last_name : null)),
                    identificationType: currentDocType ?? firstPaxDocType ?? null,
                    identification: getValidatedDocument(
                        currentPax.document_number,
                        currentDocType,
                        firstPaxOriginal.document_number,
                        firstPaxDocType
                    ),
                    type: (currentPax.type === 'AD' ? 'AD' : 'CH') as 'AD' | 'CH',
                    birth_date: birth_date,  // ✅ YA ESTÁ EN FORMATO YYYY-MM-DD
                    age: Age,
                    email: (isValidEmail(currentPax.email) ? currentPax.email :
                           (isValidEmail(firstPaxOriginal.email) ? firstPaxOriginal.email : null)),
                    phone: (isValidPhone(currentPax.phone) ? currentPax.phone :
                           (isValidPhone(firstPaxOriginal.phone) ? firstPaxOriginal.phone : null)),
                    address: (currentPax.address && currentPax.address.trim() !== '' ? currentPax.address :
                             (firstPaxOriginal.address && firstPaxOriginal.address.trim() !== '' ? firstPaxOriginal.address : null)),
                    country: (currentPax.country_id && currentPax.country_id.trim() !== '' ? currentPax.country_id :
                             (firstPaxOriginal.country_id && firstPaxOriginal.country_id.trim() !== '' ? firstPaxOriginal.country_id : null)),
                    city: (currentPax.city && currentPax.city.trim() !== '' ? currentPax.city :
                          (firstPaxOriginal.city && firstPaxOriginal.city.trim() !== '' ? firstPaxOriginal.city : null)),
                    idUnique: currentPax.idUnique ?? null,
                    state: (currentPax.state_id && currentPax.state_id.trim() !== '' ? currentPax.state_id :
                           (firstPaxOriginal.state_id && firstPaxOriginal.state_id.trim() !== '' ? firstPaxOriginal.state_id : null)),
                    relation_ship_catalogue_id: currentPax.relation_ship_catalogue_id ?? null,
                    holder: i === 0,
                };


                if(paxObject.identification === 'null') {
                  paxObject.identification = null;
                }

                paxesAux.push(paxObject);
                n = i + 1;

            } else {
                console.warn(`Categoría no soportada: ${category}`);
            }
        }
    }

    if(category === 'TRANSPORTS') {
        const uniquePaxesMap = new Map<string, typeof paxesAux[0]>();
        for (const pax of paxesAux) {
            if (pax.idUnique && !uniquePaxesMap.has(pax.idUnique)) {
                uniquePaxesMap.set(pax.idUnique, pax);
            }
        }
        paxesAux = Array.from(uniquePaxesMap.values());
    }

    pax = [];
    paxes = [];

    if (paxesAux.length > 0) {
        const seenClientIds = new Set();
        paxesAux = paxesAux.filter((pax: any) => {
            const clientId = pax.clientId;
            if (!clientId) {
return true;
}
            if (seenClientIds.has(clientId)) {
return false;
}
            seenClientIds.add(clientId);
            return true;
        });
    }

    return paxesAux;
}

  function questionsFn(item: any, pax: any, nameHotel: any) {
    const questPayload = [];
    const paxArr = pax[0];

    for (let i = 0; i < item.questions.length; i++) {
      const element = item.questions[i];
      // console.log('element questions ->', element);
        let questDataPayload;

        switch (element.code) {
          case 'HOTEL':
            questDataPayload = {
              code: element.code,
              text: element.text,
              required: element.required,
            };
            break;
          case 'HOTEL_NAME':
            questDataPayload = {
              code: element.code,
              text: element.text,
              required: element.required,
            };
            break;
          case 'PHONENUMBER':
            questDataPayload = {
              code: element.code,
              text: paxArr[0].phone,
              required: element.required,
            };
            break;
          case 'EMAIL':
            questDataPayload = {
              code: element.code,
              text: paxArr[0].email,
              required: element.required,
            };
            break;
          case 'MOBILE':
            questDataPayload = {
              code: element.code,
              text: paxArr[0].phone,
              required: element.required,
            };
            break;
          case 'NACIONALIDAD':
            questDataPayload = {
              code: element.code,
              text: paxArr[0].country_id,
              required: element.required,
            };
            break;
          case 'PASAPORTE':
            questDataPayload = {
              code: element.code,
              text: paxArr[0].document_number,
              required: element.required,
            };
            break;
          case 'PAX NAME':
            questDataPayload = {
              code: element.code,
              text: paxArr[0].first_name + ' ' + paxArr[0].last_name,
              required: element.required,
            };
            break;
        }
        questPayload.push(questDataPayload);
    }
    return questPayload;
  }

    function createReserve(
      payload: any,
      itineraryId: any,
      restService: RestService
    ): Promise<any> {
      return new Promise((resolve, reject) => {
        restService.doPost('app', 'send-reservation', payload).subscribe({
          // restService.doPost('app', 'send-reservation-multiple', payload).subscribe({
          next: (res: any) => {

            if(res && Array.isArray(res) && res.length === 0 ) {
              payload = {};
            }
            resolve(res);
          },
          error: (error: HttpErrorResponse) => {
            reject(error);
          }
        });
      });
    }

      function initializeRemarksSelect() {
    return {
      doublebed: false,
      adjoiningRooms: false,
      clientWillBelate: false,
      twoBeds: false,
    };






  }




// Método para construir el objeto pax con validaciones
function buildPaxObject(currentPax: any, firstPax: any, index: number): any {
    // Validar si el pax actual tiene los campos requeridos
    const isValidPax = this.isPaxValid(currentPax);

    return {
        clientId: currentPax.clientId ?? null,
        gender: getValueWithValidation(currentPax.gender, firstPax.gender, 'gender'),
        title: getValueWithValidation(currentPax.title, firstPax.title, 'title'),
        firstName: getValueWithValidation(currentPax.first_name, firstPax.first_name, 'first_name'),
        lastName: getValueWithValidation(currentPax.last_name, firstPax.last_name, 'last_name'),
        identificationType: currentPax.identificationType ?? null,
        identification: currentPax.document_number ?? null,
        type: (currentPax.type === 'AD' ? 'AD' : 'CH') as 'AD' | 'CH',
        birth_date: currentPax.birth_date ?? null,
        age: currentPax.age ?? null,
        email: getEmailWithValidation(currentPax.email, firstPax.email),
        phone: getPhoneWithValidation(currentPax.phone, firstPax.phone),
        address: getValueWithValidation(currentPax.address, firstPax.address, 'address'),
        country: getValueWithValidation(currentPax.country_id, firstPax.country, 'country_id'),
        city: getValueWithValidation(currentPax.city, firstPax.city, 'city'),
        idUnique: currentPax.idUnique ?? null,
        state: getValueWithValidation(currentPax.state_id, firstPax.state_id, 'state_id'),
        relation_ship_catalogue_id: currentPax.relation_ship_catalogue_id ?? null,
        holder: index === 0, // Solo el primero es el titular
        // Campo adicional para saber si usó valores del primer pax
        usedFirstPaxValues: !isValidPax
    };
}

// Método para validar si un pax tiene todos los campos requeridos
function isPaxValid(pax: any): boolean {
    const requiredFields = [
        'gender', 'title', 'first_name', 'last_name',
        'birth_date', 'document_number', 'email', 'phone',
        'country_id', 'state_id', 'city', 'address'
    ];

    // Verificar que todos los campos requeridos tengan valor
    for (const field of requiredFields) {
        if (!pax[field] || pax[field] === '') {
            return false;
        }
    }

    // Validaciones específicas por tipo de campo
    const validations = {
        email: isValidEmail(pax.email),
        phone: isValidPhone(pax.phone),
        document_number: isValidDocumentNumber(pax.document_number),
        first_name: isValidName(pax.first_name),
        last_name: isValidName(pax.last_name)
    };

    // Si alguna validación falla, retorna false
    return Object.values(validations).every(v => v === true);
}

// Método para obtener valor con validación
function getValueWithValidation(currentValue: any, firstPaxValue: any, fieldName: string): any {
    // Si el valor actual es válido, usarlo
    if (isFieldValid(currentValue, fieldName)) {
        return currentValue;
    }

    // Si no, usar el valor del primer pax si es válido
    if (isFieldValid(firstPaxValue, fieldName)) {
        return firstPaxValue;
    }

    // Si ninguno es válido, retornar null
    return null;
}

// Método para validar un campo específico
 function isFieldValid(value: any, fieldName: string): boolean {
    if (!value || value === '') {
        return false;
    }

    switch (fieldName) {
        case 'email':
            return isValidEmail(value);
        case 'phone':
            return isValidPhone(value);
        case 'document_number':
            return isValidDocumentNumber(value);
        case 'first_name':
        case 'last_name':
            return isValidName(value);
        case 'gender':
            return ['M', 'F', 'O'].includes(value); // M, F, O
        case 'title':
            return ['Mr', 'Mrs', 'Ms', 'Miss', 'Dr'].includes(value); // Ajustar según tus títulos
        default:
            return true; // Para otros campos, solo verificar que no esté vacío
    }
}

// Métodos de validación específicos
 function isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

 function isValidPhone(phone: string): boolean {
    const phoneRegex = /^\d{6,}$/;
    return phoneRegex.test(phone);
}

 function isValidDocumentNumber(docNumber: string): boolean {
    const docRegex = /^[0-9]+$/;
    return docRegex.test(docNumber);
}

 function isValidName(name: string): boolean {
    const nameRegex = /^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/;
    return nameRegex.test(name);
}

// Métodos específicos para email y phone (más complejos)
 function getEmailWithValidation(currentEmail: string, firstPaxEmail: string): string {
    // 1. Validar email actual
    if (this.isValidEmail(currentEmail)) {
        return currentEmail;
    }

    // 2. Si el actual no es válido, usar el del primer pax si es válido
    if (this.isValidEmail(firstPaxEmail)) {
        return firstPaxEmail;
    }

    // 3. Si ninguno es válido, retornar null
    return null;
}

 function getPhoneWithValidation(currentPhone: string, firstPaxPhone: string): string {
    // 1. Validar phone actual
    if (this.isValidPhone(currentPhone)) {
        return currentPhone;
    }

    // 2. Si el actual no es válido, usar el del primer pax si es válido
    if (this.isValidPhone(firstPaxPhone)) {
        return firstPaxPhone;
    }

    // 3. Si ninguno es válido, retornar null
    return null;
}

function buildAddonsSelectedRentacar(item: any){

  return item.addonsIncluded.map(addon => ({
    code:addon.code,
    quantity:addon.qtyOptional,
    amount:addon.totalAmount,
    currency:addon.Currency

  }));
}
